module.exports = __webpack_public_path__ + "img/correto-circulo.f8d1e46a.svg";